<script lang="ts">
  export const name = 'Down';
  export let className = '';
</script>

<svg class={className} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M27.7294 14.7949L15.662 2.7363C15.5751 2.64925 15.4719 2.58018 15.3583 2.53305C15.2447 2.48593 15.1229 2.46167 14.9999 2.46167C14.8769 2.46167 14.7551 2.48593 14.6415 2.53305C14.5279 2.58018 14.4247 2.64925 14.3378 2.7363L2.27039 14.7949C1.91882 15.1465 1.7196 15.624 1.7196 16.122C1.7196 17.1562 2.56042 17.997 3.5946 17.997H4.86609L4.86609 26.6015C4.86609 27.1201 5.28503 27.539 5.80359 27.539L13.1249 27.539V20.9765H16.4061V27.539H24.1962C24.7147 27.539 25.1337 27.1201 25.1337 26.6015V17.997H26.4052C26.9032 17.997 27.3807 17.8008 27.7323 17.4463C28.4618 16.7138 28.4618 15.5273 27.7294 14.7949Z"
  />
</svg>
